// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.description[data-v-43f67206]{\n  font-size: 14px;\n  margin-bottom: 14px;\n  line-height: 1.5;\n  text-align: left;\n  clear: both;\n  color: #f00;\n}\n.description-input[data-v-43f67206]{\n  margin-top: -8px;\n}\n.description-show[data-v-43f67206]{\n  margin-top: 0px;\n}\n", ""]);
// Exports
module.exports = exports;
